import { FilterSection } from './view';

export default FilterSection;
